export const MAIN_SCROLL_CONTAINER_ID = 'main-scroll-container';

export enum ContactListOption {
  Master = '1',
  Newsletter = '2',
  Onboarding = '3',
}
